module.exports = __webpack_public_path__ + "static/media/undraw_web_browsing_p77h 1.f3b17d71.svg";